import * as React from 'react';
import { ModalFullscreen, ArticleParagraph1, ArticleHeading2, IconClose16, IconButton } from '@cian/ui-kit';
import { Carousel } from '../../../../components/SimpleCarousel';
import { IStandardImage } from '../../../../settings';
import * as styles from './styles.css';

interface IStandardModalProps {
  open: boolean;
  onClose(visible: boolean): void;
  content: string;
  imageUrls: IStandardImage[];
  modalTitle: string;
  title: string;
}

export function StandardModal({ open, onClose, content, imageUrls, title, modalTitle }: IStandardModalProps) {
  return (
    <ModalFullscreen escape onClose={() => onClose(false)} open={open} theme="white">
      <div className={styles['container']} data-testid="standard_modal">
        <div className={styles['header']}>
          <div className={styles['wrapper']}>
            <ArticleParagraph1>{modalTitle}</ArticleParagraph1>
            <div className={styles['close']}>
              <IconButton data-testid="standard_modal_close" icon={<IconClose16 />} onClick={() => onClose(false)} />
            </div>
          </div>
        </div>
        <div className={styles['content']}>
          <div className={styles['preview']}>
            <Carousel slides={imageUrls} />
          </div>
          <div className={styles['info']}>
            <div className={styles['title']}>
              <ArticleHeading2>{title}</ArticleHeading2>
            </div>
            <ArticleParagraph1>{content}</ArticleParagraph1>
          </div>
        </div>
      </div>
    </ModalFullscreen>
  );
}
